import { ArrowBigLeft } from 'lucide-react';
import React from 'react';

import { Typography } from '@crossnokaye/ux-common';

import { Inline } from '@/ux-common/components/inline/inline';

import type { PreviewChangeData } from './setting-preview.types';

/**
 * PreviewChange
 *
 * Pure presentational atom that renders a "new value ← old value" indicator.
 * Used inside `PreviewItem` rows and anywhere a compact change display is needed.
 *
 * Both values must be pre-formatted strings — this component does no formatting.
 */
export const PreviewChange = ({
  displayCurrent,
  displayOriginal,
}: PreviewChangeData): React.ReactElement => {
  return (
    <Inline className="inline-row-sm flex-nowrap items-center min-w-0 flex-1 justify-end overflow-hidden">
      <Typography variant="body" className="min-w-0 truncate text-ckds-input-fg-new">
        {displayCurrent}
      </Typography>
      <ArrowBigLeft className="glyph glyph-sm text-ckds-input-fg-new" aria-hidden="true" />
      <Typography variant="body" className="min-w-0 truncate text-ckds-input-fg-old">
        {displayOriginal}
      </Typography>
    </Inline>
  );
};
